/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-08 17:27:10
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-16 10:57:55
 */
import Vue from 'vue'
import { vizier } from 'dc-vizier-track'

vizier.init({
  // 配置表,以下配置为常用配置以及示例，详细配置表参见附表1

  // 上报地址
  track_url: '/v2/extension_event',

  // 系统ID
  system_id: 1000,

  // 大区
  logical_region_id: process.env.VUE_APP_LOGICAL_REGION_ID,

  // 网关配置
  gw: {
    key: ['v%D5%AB%', 'F%D8%A2%A6%A6i%A3%', 'D%', '8%DA%DE%D0%D', '%D5%', '7je'], // 网关key
    secret: ['C8', 'CB', '9B', '9A', '9B', '98', 'C5', 'C4', 'C5', '9D', '9E', 'C6', '97', '99m', '96', '97', '99', '9Aj', '97', '60gijjegkh', '91', '81', ''] // 网关secret
  },

  // 上报数据实现形式  post, get, img, script, 默认post可不设置
  track_type: 'post',

  // 单页应用配置，默认单页且history，可不设置
  SPA: {
    is: true,
    mode: 'history'
  },
  debug: true,

  // PV指标自动触发配置,默认开启，可不设置
  pageview: true,

  // 需要携带的通用参数,每次提交都会带上的参数（json第一级，和deavice_id等同级）
  baseData: {
    system_id: 1004,
    logical_region_id: process.env.VUE_APP_LOGICAL_REGION_ID,
    page_name: 'GOK-mycard支付',
    page_seq: 1
  }
})
Vue.prototype.vizier = vizier.instance

console.log('dc-vizier-track', Vue.prototype.vizier, vizier.instance)
